module.exports = __webpack_public_path__ + "images/logout65d0bdaadfe9dafc45978ecd5ad6f4f3.svg";